<template>
	<div class="login-page" :class="colorMode">
		<div class="login-container">
			<div class="login-header">
				<img :src="require('@/assets/mg.png')" alt="MG" class="login-logo" />
				<h1 class="login-title">Welcome back</h1>
				<p class="login-subtitle">Sign in to Money Guided</p>
			</div>

		<div class="login">
			<h2>Login</h2>
			<v-text-field
				v-model="email"
				type="email"
				p--repend-inner-icon="mdi-gbp"
				d--ensity="compact"
				label="Email address"
				variant="solo"
				:flat="true"
				h--ide-details
				clearable
				single-line
				bg-color="white"
			/>
			<v-text-field
				v-model="password"
				:type="showPassword ? 'text' : 'password'"
				d--ensity="compact"
				label="Password"
				variant="solo"
				:flat="true"
				h--ide-details
				clearable
				single-line
				bg-color="white"
				:append-inner-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
				@click:append-inner="togglePasswordVisibility"
			/>
			<MGButton text="Login" stacked @click="login()" />

		</div>
		</div>
	</div>
</template>

<script>
import Services from '../mixins/Services';
import MGButton from './elements/MGButton.vue';

export default {
	name: 'LoginPage',
	mixins: [Services],
	components: { MGButton },
	data() {
		return {
			email: '',
			password: '',
			showPassword: false,
			colorMode: 'light',
			error: ''
		}
	},
	methods: {
		togglePasswordVisibility() {
			this.showPassword = !this.showPassword;
		},
		login() {
			if (!this.email || !this.password) return;
			this.error = '';
			this._login(this.email, this.password, (success) => {
				if (success) {
					this.$cookies.set('user', this.email, '1m');
					this.$cookies.set('pass', this.password, '1m');
					const landingPage = this.$route.query.landingpage || '/Wallet';
					this.$router.replace({ path: landingPage });
				} else {
					this.error = 'Invalid email or password';
				}
			});
		}
	},
	mounted() {
		const savedMode = localStorage.getItem('mg_color_mode');
		if (savedMode) {
			this.colorMode = savedMode;
		}
	}
}
</script>

<style scoped>
.login-page {
	position: fixed;
	inset: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 20px;
	background-color: var(--dark-bg-primary);
}

.login-page.light {
	background-color: #faf9f7;
}

.login-container {
	width: 100%;
	max-width: 400px;
}

.login-header {
	text-align: center;
	margin-bottom: 40px;
}

.login-logo {
	width: 56px;
	height: 56px;
	border-radius: 50%;
	margin-bottom: 24px;
}

.login-title {
	color: var(--dark-text-primary);
	font-size: 28px;
	margin: 0 0 8px 0;
}

.login-page.light .login-title {
	color: #333;
}

.login-subtitle {
	color: var(--dark-text-secondary);
	font-size: 15px;
	margin: 0;
}

.login-page.light .login-subtitle {
	color: #666;
}

.login-form {
	background: var(--dark-bg-secondary);
	border-radius: 16px;
	padding: 32px;
	border: 1px solid var(--dark-border);
}

.login-page.light .login-form {
	background: #fff;
	border-color: #ddd;
}

.login-error {
	background: rgba(229, 115, 115, 0.15);
	border: 1px solid #e57373;
	color: #e57373;
	padding: 12px 16px;
	border-radius: 10px;
	font-size: 14px;
	margin-bottom: 20px;
}

.input-group {
	margin-bottom: 20px;
}

.input-label {
	display: block;
	color: var(--dark-text-primary);
	font-size: 14px;
	margin-bottom: 8px;
}

.login-page.light .input-label {
	color: #333;
}

.login-input {
	width: 100%;
	padding: 12px 16px;
	background: var(--dark-bg-primary);
	border: 1px solid var(--dark-border);
	border-radius: 10px;
	color: var(--dark-text-primary);
	font-size: 15px;
	outline: none;
	transition: border-color 0.2s;
}

.login-input:focus {
	border-color: var(--dark-text-secondary);
}

.login-input::placeholder {
	color: var(--dark-text-secondary);
}

.login-page.light .login-input {
	background: #faf9f7;
	border-color: #ddd;
	color: #333;
}

.login-page.light .login-input:focus {
	border-color: #999;
}

.login-page.light .login-input::placeholder {
	color: #999;
}

.password-wrapper {
	position: relative;
}

.password-wrapper .login-input {
	padding-right: 48px;
}

.password-toggle {
	position: absolute;
	right: 12px;
	top: 50%;
	transform: translateY(-50%);
	background: transparent;
	border: none;
	color: var(--dark-text-secondary);
	cursor: pointer;
	padding: 4px;
	display: flex;
	align-items: center;
	justify-content: center;
}

.login-page.light .password-toggle {
	color: #666;
}

.login-btn {
	width: 100%;
	padding: 14px;
	background: var(--background-color-alt2);
	border: none;
	border-radius: 10px;
	color: #fff;
	font-size: 15px;
	cursor: pointer;
	transition: opacity 0.2s;
	margin-top: 8px;
}

.login-btn:hover:not(:disabled) {
	opacity: 0.9;
}

.login-btn:disabled {
	opacity: 0.5;
	cursor: default;
}
</style>
